module.exports = __webpack_public_path__ + "static/media/tap-iphone.b92de424.png";